/*
  Petite Siesta · Filtro de tallas (sep 2026)
  - Al elegir una talla, añade automáticamente las tallas "equivalentes":
      00 / RN / 1-3m / 3-6m  -> TU  (baberos, doudous… para bebé hasta ~6 meses)
      S o M                  -> S/M
      L o XL                 -> L/XL
  - Mientras haya una talla elegida, aplica "Disponibilidad: en stock"
    (requiere el filtro Disponibilidad activo en Search & Discovery).
  - Oculta TU, S/M y L/XL como opciones sueltas y como etiquetas activas.
*/
(function () {
  var KEY = 'filter.v.option.talla';
  var AVAIL = 'filter.v.availability';
  var EXTRA = ['TU', 'S/M', 'L/XL'];
  var MAP = {
    '00': ['TU'], 'RN': ['TU'], '1-3m': ['TU'], '3-6m': ['TU'],
    'S': ['S/M'], 'M': ['S/M'], 'L': ['L/XL'], 'XL': ['L/XL']
  };

  function labelFor(value) {
    var inputs = document.querySelectorAll('input[name="' + KEY + '"]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value === value) {
        var label = inputs[i].closest('label');
        if (label && label.title) return label.title.trim();
      }
    }
    return value;
  }

  function realSizes(params) {
    return params.getAll(KEY).filter(function (v) { return EXTRA.indexOf(v) === -1; });
  }

  // Preferencia de stock: 'auto' (en stock al elegir talla), 'on' o 'off'
  var PREF_KEY = 'ps-stock-pref';
  function getPref() { try { return sessionStorage.getItem(PREF_KEY) || 'auto'; } catch (e) { return 'auto'; } }
  function setPref(v) { try { sessionStorage.setItem(PREF_KEY, v); } catch (e) {} }

  function normalize(search, prevSearch) {
    var p = new URLSearchParams(search);
    var prev = new URLSearchParams(prevSearch || '');
    // Detecta si la clienta ha quitado o puesto "Solo en stock" a mano
    if (!p.toString()) setPref('auto');
    else if (prev.has(AVAIL) && !p.has(AVAIL)) setPref('off');
    else if (!prev.has(AVAIL) && p.has(AVAIL)) setPref('on');

    var real = realSizes(p);
    var extras = [];
    real.forEach(function (v) {
      (MAP[labelFor(v)] || []).forEach(function (e) {
        if (extras.indexOf(e) === -1) extras.push(e);
      });
    });
    p.delete(KEY);
    real.forEach(function (v) { p.append(KEY, v); });
    extras.forEach(function (e) { p.append(KEY, e); });

    var pref = getPref();
    var wantStock = pref === 'on' || (pref === 'auto' && real.length > 0);
    if (wantStock) p.set(AVAIL, '1'); else p.delete(AVAIL);
    return p.toString();
  }

  var STOCK_LABEL = { es: 'Solo en stock', en: 'In stock only', fr: 'En stock uniquement', de: 'Nur verfügbar' };

  function lastText(a) {
    for (var i = a.childNodes.length - 1; i >= 0; i--) {
      var n = a.childNodes[i];
      if (n.nodeType === 3 && n.nodeValue.trim()) return n;
    }
    return null;
  }

  function hideExtras() {
    var lang = (document.documentElement.lang || 'es').slice(0, 2);
    document.querySelectorAll('.active-facets__button').forEach(function (a) {
      var text = a.textContent.replace(/\s+/g, ' ').trim();
      var wrap = a.closest('facet-remove');
      if (/:\s*(TU|S\/M|L\/XL)$/.test(text)) { if (wrap) wrap.style.display = 'none'; return; }
      var hrefQ = (a.getAttribute('href') || '').split('?')[1] || '';
      var nowSizes = new URLSearchParams(window.location.search).getAll(KEY).length;
      var chipSizes = new URLSearchParams(hrefQ).getAll(KEY).length;
      if (wrap && document.getElementById('ps-size-bar') && /:/.test(text) && chipSizes < nowSizes) wrap.classList.add('ps-chip-size');
      if (a.dataset.psDone) return;
      var node = lastText(a);
      if (!node) return;
      if (node.nodeValue.indexOf(':') === -1) return;
      var href = a.getAttribute('href') || '';
      var isStock = window.location.search.indexOf('filter.v.availability') !== -1 && href.indexOf('filter.v.availability') === -1;
      var value = node.nodeValue.replace(/^[^:]*:\s*/, '').trim();
      node.nodeValue = ' ' + (isStock ? (STOCK_LABEL[lang] || STOCK_LABEL.es) : value) + ' ';
      if (isStock && wrap && document.getElementById('ps-size-bar')) wrap.classList.add('ps-chip-stock');
      a.dataset.psDone = '1';
    });
  }


  // Barra de tallas visible en la página (sin abrir el panel de filtros)
  var BAR_LABEL = { es: 'Talla', en: 'Size', fr: 'Taille', de: 'Größe' };

  function sizeOptions() {
    var seen = {}, out = [];
    document.querySelectorAll('input[name="' + KEY + '"]').forEach(function (i) {
      if (EXTRA.indexOf(i.value) !== -1 || seen[i.value]) return;
      var label = i.closest('label');
      seen[i.value] = true;
      out.push({ value: i.value, label: (label && label.title ? label.title : i.value).trim() });
    });
    return out;
  }

  function syncBar() {
    var bar = document.getElementById('ps-size-bar');
    if (!bar) return;
    var q = new URLSearchParams(window.location.search);
    var active = q.getAll(KEY);
    var tog = bar.querySelector('.ps-stock-toggle');
    if (tog) tog.setAttribute('aria-checked', q.has(AVAIL) ? 'true' : 'false');
    bar.querySelectorAll('button[data-value]').forEach(function (b) {
      var on = active.indexOf(b.dataset.value) !== -1;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function buildBar() {
    if (document.getElementById('ps-size-bar')) return;
    var anchor = document.querySelector('.active-facets-mobile');
    var opts = sizeOptions();
    if (!anchor || opts.length < 2) return;
    var lang = (document.documentElement.lang || 'es').slice(0, 2);
    var bar = document.createElement('div');
    bar.id = 'ps-size-bar';
    bar.className = 'ps-size-bar';
    bar.setAttribute('role', 'group');
    bar.setAttribute('aria-label', BAR_LABEL[lang] || BAR_LABEL.es);
    var html = '<div class="ps-size-bar__head"><span class="ps-size-bar__label">' + (BAR_LABEL[lang] || BAR_LABEL.es) + '</span>' +
      '<button type="button" class="ps-stock-toggle" role="switch" aria-checked="false"><span class="ps-stock-toggle__track" aria-hidden="true"></span>' +
      (STOCK_LABEL[lang] || STOCK_LABEL.es) + '</button></div><div class="ps-size-bar__list">';
    opts.forEach(function (o) {
      html += '<button type="button" class="ps-size-bar__btn" aria-pressed="false" data-value="' +
        o.value.replace(/"/g, '&quot;') + '">' + o.label.replace(/</g, '&lt;') + '</button>';
    });
    bar.innerHTML = html + '</div>';
    anchor.parentNode.insertBefore(bar, anchor);
    bar.addEventListener('click', function (e) {
      var tog = e.target.closest('.ps-stock-toggle');
      if (tog) {
        var q = new URLSearchParams(window.location.search);
        var on = q.has(AVAIL);
        setPref(on ? 'off' : 'on');
        q.delete('page');
        if (on) q.delete(AVAIL); else q.set(AVAIL, '1');
        FacetFiltersForm.renderPage(q.toString(), null, true);
        return;
      }
      var btn = e.target.closest('button[data-value]');
      if (!btn) return;
      var p = new URLSearchParams(window.location.search);
      var vals = p.getAll(KEY).filter(function (v) { return EXTRA.indexOf(v) === -1; });
      var i = vals.indexOf(btn.dataset.value);
      if (i === -1) vals.push(btn.dataset.value); else vals.splice(i, 1);
      p.delete(KEY); p.delete('page');
      vals.forEach(function (v) { p.append(KEY, v); });
      FacetFiltersForm.renderPage(p.toString(), null, true);
    });
    syncBar();
  }

  function init() {
    if (typeof FacetFiltersForm === 'undefined' || FacetFiltersForm.__tallas) return false;
    FacetFiltersForm.__tallas = true;
    var original = FacetFiltersForm.renderPage;
    FacetFiltersForm.renderPage = function (searchParams, event, updateURLHash) {
      var prev = FacetFiltersForm.searchParamsPrev;
      var r = original.call(FacetFiltersForm, normalize(searchParams || '', prev), event, updateURLHash);
      syncBar();
      return r;
    };
    window.addEventListener('popstate', function () { setTimeout(syncBar, 0); });
    buildBar();

    new MutationObserver(hideExtras).observe(document.body, { childList: true, subtree: true });
    hideExtras();

    // Enlaces externos (Google, menú) que traen talla sin equivalencias ni stock
    var current = window.location.search.slice(1);
    if (realSizes(new URLSearchParams(current)).length) {
      var fixed = normalize(current, current);
      if (fixed !== new URLSearchParams(current).toString()) FacetFiltersForm.renderPage(fixed, null, true);
    }
    return true;
  }

  if (!init()) document.addEventListener('DOMContentLoaded', init);
})();
